import { Link } from 'react-router-dom';
import { BRAND_LOGO } from '@/constants/brand';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <span className="inline-flex items-center justify-center rounded-lg bg-background-50 px-5 py-4">
              <img
                src={BRAND_LOGO}
                alt="Ganzheitliche Persönlichkeitsentwicklung – Stephanie Wolf"
                title="Stephanie Wolf – Ganzheitliche Persönlichkeitsentwicklung"
                className="h-16 w-auto"
              />
            </span>
            <p className="mt-5 text-sm text-background-200/80 leading-relaxed">
              Menschen stärken. Kompetenzen entwickeln. Zukunft gestalten.
            </p>
            <p className="mt-3 text-sm text-background-200/70">
              Kurskonzepte für soziale Kompetenz, Persönlichkeitsentwicklung und
              die Vorbereitung auf den Arbeitsmarkt.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="https://www.instagram.com/soziales_mindset_training"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                title="Instagram – Soziales & Mindset Training"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 text-background-100 hover:bg-accent-500 hover:text-secondary-900 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100011287900311&locale=de_DE"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                title="Facebook – Stephanie Wolf"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 text-background-100 hover:bg-accent-500 hover:text-secondary-900 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-circle-line text-xl"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/stephanie-wolf-560a2b36b/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                title="LinkedIn – Stephanie Wolf"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 text-background-100 hover:bg-accent-500 hover:text-secondary-900 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wide">
              <a href="#konzepte" className="hover:text-accent-300 cursor-pointer">
                Kurskonzepte
              </a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-200/80">
              <li>
                <a href="#konzepte" className="hover:text-accent-300 cursor-pointer">
                  Soziales-Kompetenzen & Mindset-Training©
                </a>
              </li>
              <li>
                <a href="#konzepte" className="hover:text-accent-300 cursor-pointer">
                  Ready for Work©
                </a>
              </li>
              <li>
                <a href="#vergleich" className="hover:text-accent-300 cursor-pointer">
                  Konzepte im Vergleich
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wide">
              Kontakt
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-200/80">
              <li>
                <a href="#kontakt" className="hover:text-accent-300 cursor-pointer">
                  Unverbindliches Angebot anfragen
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-accent-300 cursor-pointer">
                  Häufige Fragen
                </a>
              </li>
            </ul>
            <h4 className="mt-6 text-sm font-semibold text-background-50 uppercase tracking-wide">
              Folgen Sie mir
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-200/80">
              <li>
                <a
                  href="https://www.instagram.com/soziales_mindset_training"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-accent-300 cursor-pointer"
                >
                  <i className="ri-instagram-line text-base"></i>
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=100011287900311&locale=de_DE"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-accent-300 cursor-pointer"
                >
                  <i className="ri-facebook-circle-line text-base"></i>
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/stephanie-wolf-560a2b36b/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-accent-300 cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-base"></i>
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            © {new Date().getFullYear()} Stephanie Wolf. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6 text-xs text-background-200/70">
            <Link to="/impressum" className="hover:text-accent-300 cursor-pointer">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-accent-300 cursor-pointer">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}